import { Space, Spin, Switch, Typography } from "antd";
import { useFetcher } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFetcherBusy } from "~/hooks/useRouteActivity";

export function ShortTermStayChannelToggle({
  enabled,
  requireApproval,
  version,
  intent,
  canEdit,
}: {
  enabled?: boolean | null;
  requireApproval?: boolean | null;
  version: number;
  intent: string;
  canEdit: boolean;
}) {
  const { t } = useTranslation();
  const fetcher = useFetcher();
  const isSubmitting = useFetcherBusy(fetcher);
  const pendingAction = fetcher.formData?.get("stayAction") as string | null;

  const submit = (stayAction: string, body: Record<string, unknown>) => {
    fetcher.submit(
      {
        intent,
        stayAction,
        body: JSON.stringify({ _version: version, ...body }),
      },
      { method: "post" },
    );
  };

  return (
    <Space direction="vertical" size="small" style={{ marginTop: "1.5rem" }}>
      <Space align="center">
        <Typography.Text strong>{t("Stay_enable")}</Typography.Text>
        <Switch
          checked={Boolean(enabled)}
          disabled={!canEdit || isSubmitting}
          onChange={(checked) =>
            submit("enable", { shortTermStayEnabled: checked })
          }
        />
        {pendingAction === "enable" ? <Spin size="small" /> : null}
      </Space>
      {enabled ? (
        <Space align="center">
          <Typography.Text>{t("Stay_require_approval")}</Typography.Text>
          <Switch
            checked={Boolean(requireApproval)}
            disabled={!canEdit || isSubmitting}
            onChange={(checked) =>
              submit("approval", { stayRequireApproval: checked })
            }
          />
          {pendingAction === "approval" ? <Spin size="small" /> : null}
        </Space>
      ) : null}
    </Space>
  );
}
